import { W, H, R } from "./props";

export const WOLVES_DURATION = 29;
const CAPTIONS = [
  [0.6, 3.8, "Two shapes step out of the trees. Wolves. Taller than the cabin."],
  [4.0, 7.0, "\"Are the summoners in there?\""],
  [7.4, 10.4, "\"Come out and face your doom.\""],
  [10.8, 13.8, "The cult members charge out into the snow."],
  [14.2, 17.2, "It is over in seconds."],
  [17.6, 20.6, "Then the wolves begin to change."],
  [21.0, 24.6, "Two women stand where the wolves were. Pale. Smiling."],
  [25.0, 28.4, "The last of the cult walk out to them. Willingly. Into the dark."],
];
export const wolvesCaption = (tt) => (CAPTIONS.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;
const G = 140;
const WOLF = [[0, 14], [10, 10], [17, 4], [19, -8], [23, 1], [27, -8], [29, 3], [40, 4], [58, 6], [80, 7], [98, 8], [108, 12], [118, 22], [122, 34],
  [117, 36], [109, 26], [104, 24], [102, 40], [100, 60], [92, 60], [92, 42], [80, 36], [60, 36], [46, 36], [44, 60], [36, 60], [35, 38], [26, 32], [16, 22], [6, 20], [0, 18]];
const CULT = Array.from({ length: 9 }, (_, i) => ({ sx: 120 + i * 10, side: i % 2 ? 1 : -1, dies: 14.3 + i * 0.32, lives: i === 2 || i === 5 || i === 7, lane: (i * 7) % 12 }));
const BLOOD = Array.from({ length: 26 }, (_, i) => [(i * 47.7) % 260 + 30, G + 2 + (i * 13) % 26, 2 + (i % 4) * 2, 1 + (i % 2)]);

export function wolf(ctx, x, flip, s, t, speak) {
  ctx.save(); ctx.translate(x, G); ctx.scale(flip * s, s); ctx.translate(0, -60);
  const breath = Math.sin(t / 700) * 1.2;
  ctx.fillStyle = "#4a5568"; ctx.beginPath(); WOLF.forEach(([px, py], k) => (k ? ctx.lineTo(px, py - 1.5 + (k > 6 && k < 13 ? breath : 0)) : ctx.moveTo(px, py - 1.5))); ctx.fill();
  ctx.fillStyle = "#06070b"; ctx.beginPath(); WOLF.forEach(([px, py], k) => (k ? ctx.lineTo(px, py + (k > 6 && k < 13 ? breath : 0)) : ctx.moveTo(px, py))); ctx.fill();
  const open = speak ? Math.abs(Math.sin(t / 120)) * 4 : 0;
  ctx.fillStyle = "#3b0a0a"; ctx.fillRect(2, 16, 12, open);
  ctx.fillStyle = "#e5e7eb"; for (let i = 0; i < 4; i++) ctx.fillRect(3 + i * 3, 16, 1, 1 + open * 0.4);
  ctx.fillStyle = "#f59e0b"; ctx.fillRect(14, 8, 3, 2); ctx.fillStyle = "rgba(245,80,11,0.35)"; ctx.fillRect(12, 6, 7, 6);
  ctx.restore();
}

function woman(ctx, x, a, t, i) {
  ctx.globalAlpha = a;
  const sw = Math.round(Math.sin(t / 600 + i));
  R(ctx, "#e5e7eb", x, G - 26, 9, 26); R(ctx, "#cbd5e1", x + 1, G - 26, 3, 26);
  R(ctx, "#f1e4d8", x + 2, G - 34, 6, 8); R(ctx, "#0b0b0f", x + 1 + sw, G - 36, 8, 3); R(ctx, "#0b0b0f", x + sw, G - 33, 2, 16); R(ctx, "#0b0b0f", x + 7 + sw, G - 33, 2, 16);
  R(ctx, "#7f1d1d", x + 3, G - 30, 1, 1); R(ctx, "#7f1d1d", x + 6, G - 30, 1, 1);
  ctx.globalAlpha = 1;
}

function robe(ctx, x, y, a = 1) {
  ctx.globalAlpha = a; R(ctx, "#7f1d1d", x, y - 13, 6, 13); R(ctx, "#5c0f0f", x + 1, y - 17, 4, 5); R(ctx, "#f1e4d8", x + 2, y - 15, 2, 2); ctx.globalAlpha = 1;
}

export function drawWolves(ctx, tt, now) {
  ["#02040a", "#040811", "#060c19", "#08101f"].forEach((c, i) => R(ctx, c, 0, i * 30, W, 30));
  for (let s = 0; s < 110; s++) R(ctx, "#0a1324", s * 3, 60 + Math.abs(((s * 2.2) % 80) - 40) * 0.7, 3, H);
  for (let x = 0, i = 0; x < W; x += 16 + (i % 3) * 5, i++) { R(ctx, "#04070d", x + 4, G - 18, 3, 18); for (let k = 0; k < 5; k++) R(ctx, "#060a13", x + 5 - (2 + k * 3), G - 58 + k * 9, 4 + k * 6, 10); }
  R(ctx, "#b6c6d6", 0, G, W, H - G); R(ctx, "rgba(245,158,11,0.10)", 120, G, 80, H - G);
  const morph = tt < 17.6 ? 0 : Math.min(1, (tt - 17.6) / 3.2);
  if (tt > 14) BLOOD.forEach(([x, y, w, h], i) => { if (tt > 14.3 + i * 0.1) { R(ctx, "#7a0b0b", x, y, w, h); R(ctx, "#5a0606", x + 1, y + h, Math.max(1, w - 2), 1); } });
  CULT.forEach((c, i) => {
    if (tt < 10.8) return;
    const tx = (c.side < 0 ? 100 : 212) + (i % 3) * 6 * c.side, run = Math.min(1, (tt - 10.8) / 3.2), x = c.sx + (tx - c.sx) * run, y = G + 4 + c.lane;
    if (!c.lives && tt > c.dies) { R(ctx, "#7f1d1d", x - 4, y - 3, 12, 4); R(ctx, "#5c0f0f", x + 8, y - 3, 3, 3); R(ctx, "#8b0a0a", x - 8, y, 20, 2); return; }
    if (c.lives && tt > 25) { const k = Math.min(1, (tt - 25) / 3); robe(ctx, x + (c.side < 0 ? -1 : 1) * k * 30, y - k * 10, 1 - k); return; }
    robe(ctx, x + (tt < 14 ? Math.round(Math.sin(now / 80 + i)) : 0), y);
  });
  const ws = 1 - morph * 0.75, flick = morph > 0 && morph < 1 && Math.sin(now / 40) > 0;
  if (morph < 1 && !flick) { wolf(ctx, 118, -1, 0.85 * ws, now, tt > 4 && tt < 10.4); wolf(ctx, 202, 1, 0.85 * ws, now, tt > 4 && tt < 10.4); }
  if (morph > 0.6) {
    const a = Math.min(1, (morph - 0.6) / 0.4) * (tt > 26.5 ? Math.max(0, 1 - (tt - 26.5) / 1.8) : 1);
    woman(ctx, 110, a, now, 0); woman(ctx, 201, a, now, 1);
  }
  if (tt > 14.2 && tt < 17.2 && Math.sin(now / 55) > 0.55) { ctx.fillStyle = "rgba(160,10,10,0.35)"; ctx.fillRect(0, 0, W, H); }
  R(ctx, "#1e150d", 0, 0, 10, H); R(ctx, "#1e150d", W - 10, 0, 10, H); R(ctx, "#2a1d13", 0, 16, W, 4);
  for (let i = 0; i < 80; i++) R(ctx, "#e8f1ff", (i * 73.13 + now * 0.01) % W, (i * 41.7 + now * 0.02) % H, 1, 1);
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 0.8 ? 1 - tt / 0.8 : tt > WOLVES_DURATION - 1 ? tt - (WOLVES_DURATION - 1) : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
}
